import React from "react";
import { Link, useLocation } from "react-router-dom";

const TabMenuChain2 = () => {
  const location = useLocation();

  return (
    <>
      <ul>
        <li>
          <Link
            to="/deposit/sen"
            className={`${location.pathname == "/" ? "active" : location.pathname == "/deposit/sen" ? "active" : ""}`}
          >
            Deposit
          </Link>
        </li>
        <li>
          <Link
            to="/withdraw/sen"
            className={`${location.pathname == "/withdraw/sen" ? "active" : ""}`}
          >
            Withdraw
          </Link>
        </li>
      </ul>
    </>
  );
};

export default TabMenuChain2;
